// This file is auto-generated by @buzola/vite-plugin. Do not edit.
/* eslint-disable */

import { lazy, type ComponentType } from 'react';
import { buildRouteTree } from '@buzola/router';
import type { RouteConfig } from '@buzola/router';

import Route0 from './routes/_layout';
const Route1 = () => import('./routes/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
import Route2 from './routes/login/_layout';
const Route3 = () => import('./routes/login/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route4 = () => import('./routes/login/password-reset').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route5 = () => import('./routes/login/reset-request-success').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route6 = () => import('./routes/login/reset-request').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route7 = () => import('./routes/api-keys').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route8 = () => import('./routes/community/alumni-jobs/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route9 = () => import('./routes/community/alumni-jobs/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route10 = () => import('./routes/community/alumni-jobs/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route11 = () => import('./routes/community/alumni-stories/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route12 = () => import('./routes/community/alumni-stories/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route13 = () => import('./routes/community/alumni-stories/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route14 = () => import('./routes/community/auspices/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route15 = () => import('./routes/community/auspices/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route16 = () => import('./routes/community/auspices/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route17 = () => import('./routes/community/friends/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route18 = () => import('./routes/community/friends/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route19 = () => import('./routes/community/friends/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route20 = () => import('./routes/community/hub-members/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route21 = () => import('./routes/community/hub-members/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route22 = () => import('./routes/community/hub-members/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route23 = () => import('./routes/community/institutions/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route24 = () => import('./routes/community/institutions/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route25 = () => import('./routes/community/institutions/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route26 = () => import('./routes/community/interns/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route27 = () => import('./routes/community/interns/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route28 = () => import('./routes/community/interns/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route29 = () => import('./routes/community/mentors/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route30 = () => import('./routes/community/mentors/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route31 = () => import('./routes/community/mentors/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route32 = () => import('./routes/community/team/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route33 = () => import('./routes/community/team/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route34 = () => import('./routes/community/team/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route35 = () => import('./routes/community/voice-gatherings/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route36 = () => import('./routes/community/voice-gatherings/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route37 = () => import('./routes/community/voice-gatherings/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route38 = () => import('./routes/community/voice-participants/create').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route39 = () => import('./routes/community/voice-participants/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route40 = () => import('./routes/community/voice-participants/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route41 = () => import('./routes/faq-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route42 = () => import('./routes/faqs').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route43 = () => import('./routes/footer').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route44 = () => import('./routes/forms/definitions/edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route45 = () => import('./routes/forms/definitions/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route46 = () => import('./routes/forms/submissions/detail').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route47 = () => import('./routes/forms/submissions/index').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route48 = () => import('./routes/forms/zoho').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route49 = () => import('./routes/languages').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route50 = () => import('./routes/members').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route51 = () => import('./routes/navigation').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route52 = () => import('./routes/page-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route53 = () => import('./routes/pages').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route54 = () => import('./routes/partner-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route55 = () => import('./routes/partners').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route56 = () => import('./routes/program-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route57 = () => import('./routes/programs').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route58 = () => import('./routes/redirect-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route59 = () => import('./routes/redirects').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route60 = () => import('./routes/settings').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route61 = () => import('./routes/testimonial-edit').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;
const Route62 = () => import('./routes/testimonials').then(m => ({ default: m.default.component })) as Promise<{ default: ComponentType }>;

// Module augmentation for type-safe page-centric routing
declare module '@buzola/router' {
  interface BuzolaPageMap {
    'index': {};
    'login': {};
    'login/password-reset': {};
    'login/reset-request-success': {};
    'login/reset-request': {};
    'api-keys': {};
    'community/alumni-jobs/create': {};
    'community/alumni-jobs/edit': { id: string };
    'community/alumni-jobs': {};
    'community/alumni-stories/create': {};
    'community/alumni-stories/edit': { id: string };
    'community/alumni-stories': {};
    'community/auspices/create': {};
    'community/auspices/edit': { id: string };
    'community/auspices': {};
    'community/friends/create': {};
    'community/friends/edit': { id: string };
    'community/friends': {};
    'community/hub-members/create': {};
    'community/hub-members/edit': { id: string };
    'community/hub-members': {};
    'community/institutions/create': {};
    'community/institutions/edit': { id: string };
    'community/institutions': {};
    'community/interns/create': {};
    'community/interns/edit': { id: string };
    'community/interns': {};
    'community/mentors/create': {};
    'community/mentors/edit': { id: string };
    'community/mentors': {};
    'community/team/create': {};
    'community/team/edit': { id: string };
    'community/team': {};
    'community/voice-gatherings/create': {};
    'community/voice-gatherings/edit': { id: string };
    'community/voice-gatherings': {};
    'community/voice-participants/create': {};
    'community/voice-participants/edit': { id: string };
    'community/voice-participants': {};
    'faq-edit': { id?: string };
    'faqs': {};
    'footer': {};
    'forms/definitions/edit': { id: string };
    'forms/definitions': {};
    'forms/submissions/detail': { id: string };
    'forms/submissions': {};
    'forms/zoho': {};
    'languages': {};
    'members': {};
    'navigation': {};
    'page-edit': { id: string };
    'pages': {};
    'partner-edit': { id?: string };
    'partners': {};
    'program-edit': { id?: string };
    'programs': {};
    'redirect-edit': { id?: string };
    'redirects': {};
    'settings': {};
    'testimonial-edit': { id?: string };
    'testimonials': {};
  }
}

// Page registry — page ID → route pattern
export const pageRegistry: Record<string, string> = {
  'index': '/',
  'login': '/login',
  'login/password-reset': '/login/password-reset',
  'login/reset-request-success': '/login/reset-request-success',
  'login/reset-request': '/login/reset-request',
  'api-keys': '/api-keys',
  'community/alumni-jobs/create': '/community/alumni-jobs/create',
  'community/alumni-jobs/edit': '/community/alumni-jobs/edit',
  'community/alumni-jobs': '/community/alumni-jobs',
  'community/alumni-stories/create': '/community/alumni-stories/create',
  'community/alumni-stories/edit': '/community/alumni-stories/edit',
  'community/alumni-stories': '/community/alumni-stories',
  'community/auspices/create': '/community/auspices/create',
  'community/auspices/edit': '/community/auspices/edit',
  'community/auspices': '/community/auspices',
  'community/friends/create': '/community/friends/create',
  'community/friends/edit': '/community/friends/edit',
  'community/friends': '/community/friends',
  'community/hub-members/create': '/community/hub-members/create',
  'community/hub-members/edit': '/community/hub-members/edit',
  'community/hub-members': '/community/hub-members',
  'community/institutions/create': '/community/institutions/create',
  'community/institutions/edit': '/community/institutions/edit',
  'community/institutions': '/community/institutions',
  'community/interns/create': '/community/interns/create',
  'community/interns/edit': '/community/interns/edit',
  'community/interns': '/community/interns',
  'community/mentors/create': '/community/mentors/create',
  'community/mentors/edit': '/community/mentors/edit',
  'community/mentors': '/community/mentors',
  'community/team/create': '/community/team/create',
  'community/team/edit': '/community/team/edit',
  'community/team': '/community/team',
  'community/voice-gatherings/create': '/community/voice-gatherings/create',
  'community/voice-gatherings/edit': '/community/voice-gatherings/edit',
  'community/voice-gatherings': '/community/voice-gatherings',
  'community/voice-participants/create': '/community/voice-participants/create',
  'community/voice-participants/edit': '/community/voice-participants/edit',
  'community/voice-participants': '/community/voice-participants',
  'faq-edit': '/faq-edit',
  'faqs': '/faqs',
  'footer': '/footer',
  'forms/definitions/edit': '/forms/definitions/edit',
  'forms/definitions': '/forms/definitions',
  'forms/submissions/detail': '/forms/submissions/detail',
  'forms/submissions': '/forms/submissions',
  'forms/zoho': '/forms/zoho',
  'languages': '/languages',
  'members': '/members',
  'navigation': '/navigation',
  'page-edit': '/page-edit',
  'pages': '/pages',
  'partner-edit': '/partner-edit',
  'partners': '/partners',
  'program-edit': '/program-edit',
  'programs': '/programs',
  'redirect-edit': '/redirect-edit',
  'redirects': '/redirects',
  'settings': '/settings',
  'testimonial-edit': '/testimonial-edit',
  'testimonials': '/testimonials',
};

const routeConfigs: RouteConfig[] = [
  {
    path: '/',
    component: Route0,
    isLayout: true,
    children: [
      {
        path: '/',
        component: lazy(Route1),
        preload: Route1,
        isIndex: true,
      },
      {
        path: '/login',
        component: Route2,
        isLayout: true,
        children: [
          {
            path: '/',
            component: lazy(Route3),
            preload: Route3,
            isIndex: true,
          },
          {
            path: '/password-reset',
            component: lazy(Route4),
            preload: Route4,
          },
          {
            path: '/reset-request-success',
            component: lazy(Route5),
            preload: Route5,
          },
          {
            path: '/reset-request',
            component: lazy(Route6),
            preload: Route6,
          },
        ],
      },
      {
        path: '/api-keys',
        component: lazy(Route7),
        preload: Route7,
      },
      {
        path: '/community/alumni-jobs/create',
        component: lazy(Route8),
        preload: Route8,
      },
      {
        path: '/community/alumni-jobs/edit',
        component: lazy(Route9),
        preload: Route9,
      },
      {
        path: '/community/alumni-jobs',
        component: lazy(Route10),
        preload: Route10,
      },
      {
        path: '/community/alumni-stories/create',
        component: lazy(Route11),
        preload: Route11,
      },
      {
        path: '/community/alumni-stories/edit',
        component: lazy(Route12),
        preload: Route12,
      },
      {
        path: '/community/alumni-stories',
        component: lazy(Route13),
        preload: Route13,
      },
      {
        path: '/community/auspices/create',
        component: lazy(Route14),
        preload: Route14,
      },
      {
        path: '/community/auspices/edit',
        component: lazy(Route15),
        preload: Route15,
      },
      {
        path: '/community/auspices',
        component: lazy(Route16),
        preload: Route16,
      },
      {
        path: '/community/friends/create',
        component: lazy(Route17),
        preload: Route17,
      },
      {
        path: '/community/friends/edit',
        component: lazy(Route18),
        preload: Route18,
      },
      {
        path: '/community/friends',
        component: lazy(Route19),
        preload: Route19,
      },
      {
        path: '/community/hub-members/create',
        component: lazy(Route20),
        preload: Route20,
      },
      {
        path: '/community/hub-members/edit',
        component: lazy(Route21),
        preload: Route21,
      },
      {
        path: '/community/hub-members',
        component: lazy(Route22),
        preload: Route22,
      },
      {
        path: '/community/institutions/create',
        component: lazy(Route23),
        preload: Route23,
      },
      {
        path: '/community/institutions/edit',
        component: lazy(Route24),
        preload: Route24,
      },
      {
        path: '/community/institutions',
        component: lazy(Route25),
        preload: Route25,
      },
      {
        path: '/community/interns/create',
        component: lazy(Route26),
        preload: Route26,
      },
      {
        path: '/community/interns/edit',
        component: lazy(Route27),
        preload: Route27,
      },
      {
        path: '/community/interns',
        component: lazy(Route28),
        preload: Route28,
      },
      {
        path: '/community/mentors/create',
        component: lazy(Route29),
        preload: Route29,
      },
      {
        path: '/community/mentors/edit',
        component: lazy(Route30),
        preload: Route30,
      },
      {
        path: '/community/mentors',
        component: lazy(Route31),
        preload: Route31,
      },
      {
        path: '/community/team/create',
        component: lazy(Route32),
        preload: Route32,
      },
      {
        path: '/community/team/edit',
        component: lazy(Route33),
        preload: Route33,
      },
      {
        path: '/community/team',
        component: lazy(Route34),
        preload: Route34,
      },
      {
        path: '/community/voice-gatherings/create',
        component: lazy(Route35),
        preload: Route35,
      },
      {
        path: '/community/voice-gatherings/edit',
        component: lazy(Route36),
        preload: Route36,
      },
      {
        path: '/community/voice-gatherings',
        component: lazy(Route37),
        preload: Route37,
      },
      {
        path: '/community/voice-participants/create',
        component: lazy(Route38),
        preload: Route38,
      },
      {
        path: '/community/voice-participants/edit',
        component: lazy(Route39),
        preload: Route39,
      },
      {
        path: '/community/voice-participants',
        component: lazy(Route40),
        preload: Route40,
      },
      {
        path: '/faq-edit',
        component: lazy(Route41),
        preload: Route41,
      },
      {
        path: '/faqs',
        component: lazy(Route42),
        preload: Route42,
      },
      {
        path: '/footer',
        component: lazy(Route43),
        preload: Route43,
      },
      {
        path: '/forms/definitions/edit',
        component: lazy(Route44),
        preload: Route44,
      },
      {
        path: '/forms/definitions',
        component: lazy(Route45),
        preload: Route45,
      },
      {
        path: '/forms/submissions/detail',
        component: lazy(Route46),
        preload: Route46,
      },
      {
        path: '/forms/submissions',
        component: lazy(Route47),
        preload: Route47,
      },
      {
        path: '/forms/zoho',
        component: lazy(Route48),
        preload: Route48,
      },
      {
        path: '/languages',
        component: lazy(Route49),
        preload: Route49,
      },
      {
        path: '/members',
        component: lazy(Route50),
        preload: Route50,
      },
      {
        path: '/navigation',
        component: lazy(Route51),
        preload: Route51,
      },
      {
        path: '/page-edit',
        component: lazy(Route52),
        preload: Route52,
      },
      {
        path: '/pages',
        component: lazy(Route53),
        preload: Route53,
      },
      {
        path: '/partner-edit',
        component: lazy(Route54),
        preload: Route54,
      },
      {
        path: '/partners',
        component: lazy(Route55),
        preload: Route55,
      },
      {
        path: '/program-edit',
        component: lazy(Route56),
        preload: Route56,
      },
      {
        path: '/programs',
        component: lazy(Route57),
        preload: Route57,
      },
      {
        path: '/redirect-edit',
        component: lazy(Route58),
        preload: Route58,
      },
      {
        path: '/redirects',
        component: lazy(Route59),
        preload: Route59,
      },
      {
        path: '/settings',
        component: lazy(Route60),
        preload: Route60,
      },
      {
        path: '/testimonial-edit',
        component: lazy(Route61),
        preload: Route61,
      },
      {
        path: '/testimonials',
        component: lazy(Route62),
        preload: Route62,
      },
    ],
  },
];

export const routes = buildRouteTree(routeConfigs);
